import Config from "../Config";
import { authHeaderLicman } from "../helpers/requestHelpers";

const config = new Config();

/**
 * Loads platform Adyen margin per customer for a date range (admin panel).
 *
 * @param {{ from: string, to: string }} params - Inclusive ISO dates YYYY-MM-DD
 * @returns {Promise<Object>} Aggregation payload from fgfunctions
 */
export function fetchPlatformAdyenMargin({ from, to }) {
    return async function () {
        const query = new URLSearchParams({ from, to }).toString();
        const requestOptions = {
            method: "GET",
            headers: authHeaderLicman(),
        };

        const response = await fetch(
            `${config.apiUrl}/${config.licmanModule}/getPlatformAdyenMargin?${query}`,
            requestOptions
        );

        let body = null;
        try {
            body = await response.json();
        } catch {
            body = null;
        }

        if (!response.ok) {
            const message =
                (body && (body.error || body.errorMessage || body.details)) ||
                `Request failed with status ${response.status}`;
            const error = new Error(typeof message === "string" ? message : JSON.stringify(message));
            error.status = response.status;
            error.body = body;
            throw error;
        }

        return body;
    };
}
